import { getFormValues } from 'redux-form';
import * as actionTypes from './gridActionTypes';

export const registerGrid = (gridName, primaryKey) => ({
    type: actionTypes.REGISTER_GRID,
    gridName,
    primaryKey
});

export const unregisterGrid = gridName => ({
    type: actionTypes.UNREGISTER_GRID,
    gridName
});
export const refreshGrid = gridName => ({
    type: actionTypes.REFRESH_GRID,
    gridName
});
export const refreshAll = () => ({
    type: actionTypes.REFRESH_ALL
});
export const clearRefresh = gridName => ({
    type: actionTypes.GRID_REFRESHED,
    gridName
});
export const refreshPagination = gridName => ({
    type: actionTypes.REFRESH_PAGINATION,
    gridName
});

export const loadGridData = (gridName, response) => ({
    type: actionTypes.LOAD_GRID_DATA,
    gridName,
    response
});
export const sortGrid = (gridName, sortBy) => ({
    type: actionTypes.SORT_GRID,
    gridName,
    sortBy
});

export const filterGrid = (gridName, filter) => ({
    type: actionTypes.FILTER_GRID,
    gridName,
    filter
});

export const filterHomePageGrid = (gridName, filter) => ({
    type: actionTypes.FILTER_HOME_PAGE_GRID,
    gridName,
    filter
});

export const toggleAdvancedSearch = gridName => ({
    type: actionTypes.TOGGLE_ADVANCED_SEARCH,
    gridName
});

/** To display unhidable advance search filters
 * SAF-17155-Create IB Notifications List View with filters for Admin Workflow
 * Release: 7.0
 * Author: Sourabh
 * */
export const showAdvancedSearch = gridName => ({
    type: actionTypes.SHOW_ADVANCED_SEARCH,
    gridName
});

export const changePageLength = (gridName, pageLength) => ({
    type: actionTypes.CHANGE_PAGE_LENGTH,
    gridName,
    pageLength
});

export const goToPage = (gridName, pageNumber) => ({
    type: actionTypes.GOTO_PAGE,
    gridName,
    pageNumber
});
export const nextPage = gridName => ({
    type: actionTypes.NEXT_PAGE,
    gridName
});
export const previousPage = gridName => ({
    type: actionTypes.PREV_PAGE,
    gridName
});
export const firstPage = gridName => ({
    type: actionTypes.FIRST_PAGE,
    gridName
});
export const lastPage = gridName => ({
    type: actionTypes.LAST_PAGE,
    gridName
});

export const updateAdvancedSearch = (gridName, actionCreator) => (dispatch, getState) => {
    const formName = `${gridName}_advancedSearch`;
    dispatch(actionCreator(formName));
    dispatch(filterGrid(gridName, getFormValues(formName)(getState())));
};

export const updateActionValues = (gridName, formName) => (dispatch, getState) => {
    dispatch(countryGridActions(gridName, getFormValues(formName)(getState())));
};

export const updateBlkSnActionValues = (gridName, formName) => (dispatch, getState) => {
    dispatch(snGridActions(gridName, getFormValues(formName)(getState())));
};

export const countryGridActions = (gridName, countriesList) => {
    return {
        type: actionTypes.COUNTRY_GRID_ACTION,
        gridName,
        countriesList
    };
};

export const snGridActions = (gridName, filterEligibleAndNoteligibelSN) => {
    return {
        type: actionTypes.SN_GRID_ACTION,
        gridName,
        filterEligibleAndNoteligibelSN
    };
};

export const refreshRecipient = (gridName, actionCreator) => (dispatch, getState) => {
    const formName = `${gridName}_advancedSearch`;
    dispatch(actionCreator(formName));
    dispatch(refreshFilters(gridName, getFormValues(formName)(getState())));
};
//SAF - 17466 refreshes the grid for IB recipient list view
export const refreshIBRecipient = (gridName, actionCreator) => (dispatch, getState) => {
    const formName = `${gridName}_advancedSearch`;
    dispatch(actionCreator(formName));
    dispatch(refreshIBFilters(gridName, getFormValues(formName)(getState())));
};

export const refreshFilters = gridName => ({
    type: actionTypes.REFRESH_RECIPIENT,
    gridName
});

export const refreshIBFilters = gridName => ({
    type: actionTypes.REFRESH_IB_RECIPIENT,
    gridName
});

export const refreshManagement = (gridName, actionCreator) => (dispatch, getState) => {
    const formName = `${gridName}_advancedSearch`;
    dispatch(actionCreator(formName));
    dispatch(refreshFiltersManagement(gridName, getFormValues(formName)(getState())));
};

export const refreshFiltersManagement = gridName =>({
    type: actionTypes.REFRESH_MANAGEMENT,
    gridName
});

export const refreshSort = (gridName , filter)=> ({
    type: actionTypes.REFRESH_SORT,
    gridName,
    filter
})